var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"value":_vm.value,"width":"500px","persistent":""}},[_c('v-card',[_c('v-card-title',[_vm._v("Enviar e-mail de teste")]),_c('v-card-text',[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"10"}},[_c('label',{staticClass:"detail-title"},[_vm._v("Destinatário para e-mail de teste")]),_c('v-text-field',{staticClass:"mb-0",attrs:{"outlined":"","hide-details":""},model:{value:(_vm.recipient),callback:function ($$v) {_vm.recipient=$$v},expression:"recipient"}})],1)],1),_c('mf-action-buttons',{attrs:{"primary-button":{
          text: 'Enviar',
          action: _vm.send,
          isVisible: true,
          isLoading: _vm.loading,
        },"extra-button":{
          text: 'Cancelar',
          action: function () { return _vm.$emit('input', false); },
          isVisible: true,
          isDisabled: _vm.loading,
        }}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }